import { CharacterAttack } from './CharacterAttack';

export class AttackBeastboySpecialStanding extends CharacterAttack {
  updateAttackCollider() {}

  _triggerAttackAnimation() {
    this.attackCollider.enabled = false;
    this._character.bodyCollider.enabled = false;
    this._character.playAnimation('standing_special_intro', false, this._handleAttack, this);
  }

  _handleAttack() {
    this.attackCollider.enabled = true;
    this._character.playAnimation('standing_special_loop', false, this._endAttack, this);
    this.attackCollider.width = 0;
    this.attackCollider.height = this.character.bodyCollider.height;
    this.attackCollider.x = this.character.x;
    this.attackCollider.y = this.character.y - this.attackCollider.height;
    this.scene.tweens.add({
      targets: this.attackCollider,
      width: 500,
      x: this.character.x - 250,
      duration: 150,
      delay: 200,
      onComplete: this.disableAttackCollider,
      onCompleteScope: this,
      yoyo: true,
      repeat: 1,
      repeatDelay: 250,
    });
  }

  _endAttack() {
    this.attackCollider.enabled = false;
    this._character.playAnimation('standing_special_out', false, this.completeAttack, this);
  }

  completeAttack() {
    this._character.bodyCollider.enabled = true;
    super.completeAttack();
  }
}
